import Eyebrow from "@/components/base/Eyebrow";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  center?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  center = false,
}: SectionHeadingProps) {
  return (
    <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <div className={`flex items-center gap-3 ${center ? "justify-center" : ""}`}>
          <Eyebrow>{eyebrow}</Eyebrow>
        </div>
      )}
      <h2 className="mt-4 font-heading font-black uppercase leading-[0.95] tracking-tight text-foreground-950 text-3xl md:text-5xl">
        {title}
      </h2>
      {description && (
        <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600">
          {description}
        </p>
      )}
    </div>
  );
}